import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
function BreakdownChartFilterSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-1"><div className="flex w-fit items-center gap-2"><span className="text-base leading-[120%] font-bold lg:text-lg 2xl:text-xl">Breakdown Chart</span><Skeleton className="h-4 w-4 rounded-full" /><Skeleton className="h-4 w-4 rounded-full" /></div><Skeleton className="h-4 w-24" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-row flex-wrap items-start justify-between">{t0}<div className="hidden items-center gap-4 md:flex"><Skeleton className="h-5 w-20" /><Skeleton className="h-9 w-[184px] rounded-md" /><Skeleton className="h-9 w-[184px] rounded-md" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export { BreakdownChartFilterSkeleton };